var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInputCross = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 10C0 15.5229 4.47715 20 10 20C15.5228 20 20 15.5229 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10ZM6.51523 5L10.0508 8.53553L13.5863 5L15.1015 6.51523L11.566 10.0508L15.1015 13.5863L13.5863 15.1015L10.0508 11.566L6.51523 15.1015L5 13.5863L8.53553 10.0508L5 6.51523L6.51523 5Z",
  fill: "rgba(23, 23, 23, .3)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInputCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/input-cross.9941f9388e06a3db8c5cb1f735fef045.svg";